import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getQrCodeApi,
magicApi
} from "../api/MagicApi";

// Async thunks for API calls
export const checkImage = createAsyncThunk(
  "magic/checkImage",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await magicApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const getQrCode = createAsyncThunk(
  "magic/getQrCode",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getQrCodeApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);




// Initial state
const initialState = {
    magicData:null,
    loading: false,
  error: null,
  isOtpVerified: false,
  qrdata:null
};

// Slice definition
const MagicSlice = createSlice({
  name: "magic",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(checkImage.pending, (state) => {
        state.loading = true;
      })
      .addCase(checkImage.fulfilled, (state,action) => {
        state.loading = false;
        state.magicData = action.payload.magic;
      })
      .addCase(checkImage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
     

      builder.addCase(getQrCode.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getQrCode.fulfilled, (state,action) => {
        state.loading = false;
        state.qrdata = action.payload;
      })
      .addCase(getQrCode.rejected, (state, action) => {
        state.loading = false;
        state.error = action?.payload?.errorMessage || action.error.message;
      });
  },
});

export default MagicSlice.reducer;
